/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { AccountType } from '../enums/account-type';
import { CountryCode } from '../enums/country-code';
import { Industry } from '../enums/industry';
import { PreferredVideoClient } from '../enums/preferred-video-client';
import { ContactEntity } from './contact-entity';
import { UserEntity } from './user-entity';
export class AccountEntity extends Entity {
  accountType: AccountType | null = null;
  businessTeam: string | null = null;
  confidentialAccountName: string | null = null;
  contacts: ContactEntity[] = [];
  createdAt: string | null = null;
  currency: string | null = null;
  cxPartner: UserEntity | null = null;
  cxPartnerId: string | null = null;
  denied: boolean = false;
  displayName: string | null = null;
  emailsOptedOut: string[] | null = null;
  hqAddressCountry: CountryCode | null = null;
  hqAddressState: string | null = null;
  id: string = '';
  industryValue: Industry | null = null;
  integrationId: string | null = null;
  isAccountConfidential: boolean | null = null;
  lawyerOnStaff: boolean = false;
  name: string | null = null;
  ownerUser: UserEntity | null = null;
  ownerUserId: string | null = null;
  ownerUserRole: string | null = null;
  parentAccount: AccountEntity | null = null;
  parentAccountId: string | null = null;
  preferredVideoClient: PreferredVideoClient | null = null;
  reassignedAt: string | null = null;
  reassignedToAccountId: string | null = null;
  region: CountryCode | null = null;
  salesforceId: string | null = null;
  subIndustryId: string | null = null;
  website: string | null = null;
  zoomIndustry: string | null = null;
  zoomRecordId: string | null = null;
  calculatedConfidentialName?: string | null = null;
  calculatedName?: string | null = null;
  static override key = 'Account';
  static override get schema() {
    return {
      contacts: [ContactEntity],
      cxPartner: UserEntity,
      ownerUser: UserEntity,
      parentAccount: AccountEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Account' in input
    ) {
      const { Account: wrapped, ...rest } = input as {
        Account: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}